import tw, { styled } from 'twin.macro';

const OneQuarterLayout = styled.div`
  ${tw`w-1/4 flex-none`}
`;

export default OneQuarterLayout;
